import React, { useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

export default function QRDialog({ open, onOpenChange, shortUrl, linkId }) {
  const svgRef = useRef(null);

  const downloadSVG = () => {
    if (!svgRef.current) return;
    const svgEl = svgRef.current.querySelector("svg");
    if (!svgEl) return;
    const src = new XMLSerializer().serializeToString(svgEl);
    const blob = new Blob([src], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `splink-${linkId}.svg`; a.click();
    URL.revokeObjectURL(url);
  };

  const downloadPNG = () => {
    if (!svgRef.current) return;
    const svgEl = svgRef.current.querySelector("svg");
    if (!svgEl) return;
    const src = new XMLSerializer().serializeToString(svgEl);
    const canvas = document.createElement("canvas");
    canvas.width = 1024; canvas.height = 1024;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    const blob = new Blob([src], { type: "image/svg+xml" });
    const svgUrl = URL.createObjectURL(blob);
    img.onload = () => {
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, 1024, 1024);
      canvas.toBlob((b) => {
        const url = URL.createObjectURL(b);
        const a = document.createElement("a");
        a.href = url; a.download = `splink-${linkId}.png`; a.click();
        URL.revokeObjectURL(url);
      }, "image/png");
      URL.revokeObjectURL(svgUrl);
    };
    img.src = svgUrl;
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none border border-border sm:max-w-md p-0" data-testid="qr-dialog">
        <DialogHeader className="p-6 border-b border-border">
          <div className="eyebrow text-muted-foreground mb-2">QR code</div>
          <DialogTitle className="font-heading text-xl font-light tracking-tight">Download & share</DialogTitle>
        </DialogHeader>
        <div className="p-8 flex flex-col items-center">
          <div ref={svgRef} className="p-6 bg-white border border-border" data-testid="qr-svg-wrapper">
            <QRCodeSVG value={shortUrl} size={220} level="M" />
          </div>
          <div className="mt-4 font-mono text-xs text-muted-foreground break-all text-center">{shortUrl}</div>
        </div>
        <div className="p-6 pt-0 grid grid-cols-2 gap-3">
          <Button data-testid="qr-download-png" onClick={downloadPNG} variant="outline" className="rounded-none border-foreground">
            <Download className="w-4 h-4 mr-2" />PNG
          </Button>
          <Button data-testid="qr-download-svg" onClick={downloadSVG} className="rounded-none bg-foreground text-background hover:bg-foreground/90">
            <Download className="w-4 h-4 mr-2" />SVG
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
